export var transactionStatus = [
  { value: -200, label: "All" },
  { value: 0, label: "Pending" },
  { value: 1, label: "Success" },  
  { value: 3, label: "Declined" },
  { value: 5, label: "Unchecked Deposit" },
  { value: 6, label: "High Risk Transfer" },
];